import { getColor } from '@chakra-ui/theme-tools'

type Props = Record<string, any>

export default {
  parts: ['field'],
  sizes: {
    sm: {
      field: {
        color: 'black',
        borderRadius: 0,
        padding: '7px',
      },
    },
    md: {
      field: {
        color: 'black',
        borderRadius: 0,
        padding: '7px',
      },
    },
  },
  variants: {
    outline: (props: Props) => {
      const { theme } = props
      return {
        field: {
          _readOnly: {
            userSelect: 'text',
          },
          _focus: {
            borderColor: props.isInvalid ? 'red.500' : 'blue.500',
            boxShadow: props.isInvalid
              ? `0 0 0 1px ${getColor(theme, 'red.500')}`
              : `0 0 0 1px ${getColor(theme, 'blue.500')}`,
          },
        },
      }
    },
  },
}
